import SuperFetch from '../../../superFetch.js';

class AccountUserApi {
  /**
   *  [유저] 유저 리스트 요청하기
   */
  getAccountUserList = (data) => SuperFetch.post('/account/user/list/all', data);

  /**
   *  [유저] 유저 excel 리스트 다운로드하기
   */
  getAccountUserExcelDownload = (data) => SuperFetch.post('/account/user/list/excel/download', data);

  /**
   *  [유저] 유저 랭크 리스트 요청하기
   */
  getAccountUserRankList = (data) => SuperFetch.post('/account/user/rank/all', data);

  /**
   *  [유저] 유저 랭킹 리스트 excel 다운로드하기
   */
  getAccountUserRankExcelDownload = (data) => SuperFetch.post('/account/user/rank/excel/download', data);

  /**
   * [유저] 유저 상세 주문 정보 요청하기
   */
  getAccountUserOrderDetail = (data) => SuperFetch.post('/account/user/detail/order', data);

  /**
   * [유저] 유저 상세 쿠폰 정보 요청하기
   */
  getAccountUserCouponDetail = (data) => SuperFetch.post('/account/user/detail/coupon', data);

  /**
   * [유저] 유저 상세 포인트 정보 요청하기
   */
  getAccountUserPointDetail = (data) => SuperFetch.post('/account/user/detail/point', data);

  /**
   * [유저] 유저 상세 장바구니 정보 요청하기
   */
  getAccountUserCartDetail = (data) => SuperFetch.post('/account/user/detail/cart', data);

  /**
   * [유저] 유저 상세 1:1 문의 내역 정보 요청하기
   */
  getAccountUserCsInquiryDetail = (data) => SuperFetch.post('/account/user/detail/cs/inquiry', data);

  /**
   * [유저] 유저 상세 상품 문의 내역 정보 요청하기
   */
  getAccountUserCsQnaDetail = (data) => SuperFetch.post('/account/user/detail/cs/qna', data);

  /**
   * [유저] 유저 상세 상품 후기 정보 요청하기
   */
  getAccountUserCsReviewDetail = (data) => SuperFetch.post('/account/user/detail/cs/review', data);

  /**
   * [유저] 유저 상세 팔로우한 태그 정보 요청하기
   */
  getAccountUserTagDetail = (data) => SuperFetch.post('/account/user/detail/tag', data);

  /**
   * [유저] 유저 상세 좋아요한 상품 정보 요청하기
   */
  getAccountUserLikeProductDetail = (data) => SuperFetch.post('/account/user/detail/like/product', data);

  /**
   * [유저] 유저 상세 좋아요한 브랜드 정보 요청하기
   */
  getAccountUserLikeBrandDetail = (data) => SuperFetch.post('/account/user/detail/like/brand', data);

  /**
   * [유저] 유저 상세 정보 중 장바구니 리스트 요청하기
   */
  getAccountUserDetailCartList = (data) => SuperFetch.post('/account/user/detail/cart/list', data);

  /**
   * [유저] 유저 상세 정보 중 장바구니 타임라인 리스트 요청하기
   */
  getAccountUserDetailCartLogList = (data) => SuperFetch.post('/account/user/detail/cart/log/list', data);

  /**
   * [유저] 유저 상세 정보 중 1:1 문의 내역 리스트 요청하기
   */
  getAccountUserDetailCsInquiryList = (data) => SuperFetch.post('/account/user/detail/cs/inquiry/list', data);

  /**
   * [유저] 유저 상세 정보 중 1:1 문의 내역 리스트 엑셀 다운로드 요청하기
   */
  getAccountUserDetailCsInquiryListExcelDownload = (data) =>
    SuperFetch.post('/account/user/detail/cs/inquiry/list/excel/download', data);

  /**
   * [유저] 유저 상세 정보 중 상품 문의 내역 리스트 요청하기
   */
  getAccountUserDetailCsQnaList = (data) => SuperFetch.post('/account/user/detail/cs/qna/list', data);

  /**
   * [유저] 유저 상세 정보 중 상품 문의 내역 리스트 엑셀 다운로드 요청하기
   */
  getAccountUserDetailCsQnaListExcelDownload = (data) =>
    SuperFetch.post('/account/user/detail/cs/qna/list/excel/download', data);

  /**
   * [유저] 유저 상세 정보 중 상품 후기 리스트 요청하기
   */
  getAccountUserDetailCsReviewList = (data) => SuperFetch.post('/account/user/detail/cs/review/list', data);

  /**
   * [유저] 유저 상세 정보 중 상품 후기 리스트 엑셀 다운로드 요청하기
   */
  getAccountUserDetailCsReviewListExcelDownload = (data) =>
    SuperFetch.post('/account/user/detail/cs/review/list/excel/download', data);

  /**
   * [유저] 유저 상세 정보 중 팔로우 태그 리스트 요청하기
   */
  getAccountUserDetailTagList = (data) => SuperFetch.post('/account/user/detail/tag/list', data);

  /**
   * [유저] 유저 상세 정보 중 태그 타임라인 리스트 요청하기
   */
  getAccountUserDetailTagLogList = (data) => SuperFetch.post('/account/user/detail/tag/log/list', data);

  /**
   * [유저] 유저 상세 정보 중 좋아요한 상품 리스트 요청하기
   */
  getAccountUserDetailLikeProductList = (data) => SuperFetch.post('/account/user/detail/like/product/list', data);

  /**
   * [유저] 유저 상세 정보 중 상품 좋아요 타임라인 리스트 요청하기
   */
  getAccountUserDetailLikeProductLogList = (data) =>
    SuperFetch.post('/account/user/detail/like/product/log/list', data);

  /**
   * [유저] 유저 상세 정보 중 좋아요한 브랜드 리스트 요청하기
   */
  getAccountUserDetailLikeBrandList = (data) => SuperFetch.post('/account/user/detail/like/brand/list', data);

  /**
   * [유저] 유저 상세 정보 중 브랜드 좋아요 타임라인 리스트 요청하기
   */
  getAccountUserDetailLikeBrandLogList = (data) => SuperFetch.post('/account/user/detail/like/brand/log/list', data);

  /**
   *  [유저] 유저 상세 정보 중 주문 리스트 요청하기
   */
  getAccountUserDetailOrderList = (data) => SuperFetch.post('/account/user/detail/order/list', data);

  /**
   *  [유저] 유저 상세 정보 중 쿠폰 리스트 요청하기
   */
  getAccountUserDetailCouponList = (data) => SuperFetch.post('/account/user/detail/coupon/list', data);

  /**
   *  [유저] 유저 상세 정보 중 포인트 리스트 요청하기
   */
  getAccountUserDetailPointList = (data) => SuperFetch.post('/account/user/detail/point/list', data);

  /**
   *  [유저] 유저 상세 정보 편집 요청하기
   */
  editUserDetail = (data) => SuperFetch.post('/account/user/detail/user/update', data);
}

export default new AccountUserApi();
